import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID, Renderer2, ElementRef, ViewChild, HostListener, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { CompanyService } from '../../services/company.service';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AppDataService } from '../../services/app-data.service';
import { TranslationService } from '../../services/translation.service';
import { MessagingService } from '../../messaging.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder } from '@angular/forms';
import { MenuConfigurationBean } from '../../beansts/menu.configuration.bean';
import { CompanyBean } from '../../beansts/company.bean';
import { EventBean } from '../../beansts/Event';
import { EventComponent } from '../+gameevent/event.component';
import { WalletService } from '../../services/wallet.services';
declare var Swiper: any;
declare var $ : any;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'app-treinamento',
  templateUrl: './treinamento.component.html',
   styleUrls: ['./treinamento.component.css']
})
export class TreinamentoComponent extends EventComponent implements OnInit{
  videoTitle: string | null = null;
  room: string | null = null;
  selectedVideoSection: any;
  companyData: any;
  isModalOpen: boolean;
  menuConfig: MenuConfigurationBean;

  public event: EventBean=new EventBean();
  public buyerGold=0

  public photo='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Fbackgrounds%2Ftela%20fundo%20reuniao.jpeg?alt=media&token=2303f2d4-4b37-4531-aca0-c26b489a5465'
  public muted;

  public endDate=''
  public startDate=''
  public queryRoom=null;
  public currentActivities=[]
  public nextActivities=[]
  public oldActivities=[]

  public hasCurrentActivities=false;
  public hasNextActivities=false;
  public hasOldActivities=false;

  public user={uid:'n/a',full_name:'Anonimo',profile_picture:'nil'};

  public leave

  public companyEvents:EventBean [];
  public company:CompanyBean=new CompanyBean();
  router: any;

  constructor(    private renderer: Renderer2,
    public route: ActivatedRoute,
    public _companyService: CompanyService,
    public _router: Router,
    public _appData: AppDataService,
    public _routeParams : ActivatedRoute,     @Inject(PLATFORM_ID) private platformId: Object,

    public _sanitizer: DomSanitizer,public translate: TranslationService, public _walletService : WalletService, public msgService: MessagingService,public fb : FormBuilder
  ) {

    super( _sanitizer, translate, _router,_routeParams, _companyService,_walletService,  _appData,msgService,fb)
    this.menuConfig=new MenuConfigurationBean();
  }
  selectedSection: any;

  trainingId: string;
  loading: boolean = true;

  ngOnInit(): void {
    const h3Element = document.querySelector('.video-text');
    if (h3Element) {
        h3Element.setAttribute(
            'style',
            'font-size: 16px; line-height: 20px; color: black !important;'
        );
    }
    this._routeParams.queryParams.subscribe(params => {
      var companyId = params.id;

      this._companyService.getLandingCompany(companyId).get().then(doc => {
        let main = document.getElementById("main");
        main.style.removeProperty("overflow");

        if (doc.exists) {
          this.companyData = doc.data();
          this._appData.gameUrl = "/gamephoto.html?room=" + this.companyData.room;
          this.loading = false; // Dados carregados
        } else {
          console.error("Documento não encontrado");
          this.loading = false;
        }
      }).catch(error => {
        console.error("Erro ao obter dados da empresa:", error);
        this.loading = false;
      });
    });


  }

  navegarParaPainelAluno(): void {
    if (isPlatformBrowser(this.platformId)) {
      this._router.navigate(['/treinamento/painel-aluno'], { queryParams: { section: 'painel-aluno' } })
        .then(success => {
          if (success) {
            console.log('Navegação para Meus Cursos realizada com sucesso!');
          } else {
            console.warn('Navegação foi impedida.');
          }
        })
        .catch(err => {
          console.error('Erro ao navegar para Meus Cursos:', err);
        });
    }
  }

  navegarParaMeusCursos(): void {
    if (isPlatformBrowser(this.platformId)) {
      this._router.navigate(['/treinamento/meus-cursos'], { queryParams: { section: 'meus-cursos' } })
        .then(success => {
          if (success) {
            console.log('Navegação para Meus Cursos realizada com sucesso!');
          } else {
            console.warn('Navegação foi impedida.');
          }
        })
        .catch(err => {
          console.error('Erro ao navegar para Meus Cursos:', err);
        });
    }
  }

  navegarParaPainelFinanceiro(): void {
    // Verifica se está no navegador
    if (isPlatformBrowser(this.platformId)) {
      this._router.navigate(['/treinamento/painel-financeiro'], { queryParams: { section: 'painel-financeiro' } })
        .then(success => {
          if (success) {
            console.log('Navegação para Meus Certificados realizada com sucesso!');
          } else {
            console.warn('Navegação foi impedida.');
          }
        })
        .catch(err => {
          console.error('Erro ao navegar para Meus Certificados:', err);
        });
    }
  }
  navegarParaMeusCertificados(): void {
    if (isPlatformBrowser(this.platformId)) {
      this._router.navigate(['/treinamento/meus-certificados'], { queryParams: { section: 'meus-certificados' } })
        .then(success => {
          if (success) {
            console.log('Navegação para Meus Certificados realizada com sucesso!');
          } else {
            console.warn('Navegação foi impedida.');
          }
        })
        .catch(err => {
          console.error('Erro ao navegar para Meus Certificados:', err);
        });
    }
  }

  navegarParaDuvidas(): void {
    if (isPlatformBrowser(this.platformId)) {
      this._router
        .navigate(['/treinamento/duvidas'])
        .then((success) => {
          if (success) {
            console.log('Navegação para "Dúvidas" realizada com sucesso!');
          } else {
            console.warn('Navegação foi impedida.');
          }
        })
        .catch((err) => {
          console.error('Erro ao navegar para "Dúvidas":', err);
        });
    } else {
      console.warn('Ambiente não é do navegador. Navegação não realizada.');
    }
  }

  navegarParaDepoimentos(): void {
    if (isPlatformBrowser(this.platformId)) {
      this._router
        .navigate(['/treinamento/depoimentos'])
        .then((success) => {
          if (success) {
            console.log('Navegação para "Depoimentos" realizada com sucesso!');
          } else {
            console.warn('Navegação foi impedida.');
          }
        })
        .catch((err) => {
          console.error('Erro ao navegar para "Depoimentos":', err);
        });
    } else {
      console.warn('Ambiente não é do navegador. Navegação não realizada.');
    }
  }
  // selectedSection: any = null;
  currentIndex = 0;
  openVideoModal(section: any) {
    this.selectedSection = section;
    this.isModalOpen = true;
    this.currentIndex = 0;

    // Atualiza a URL para incluir o título clicado
    this._router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        title: encodeURIComponent(section.kindName)
      },
      queryParamsHandling: 'merge'
    });

    document.body.classList.add('modal-open');
  }

  closeVideoModal() {
    this.isModalOpen = false;
    this.selectedSection = null;

    document.body.classList.remove('modal-open');

    // Remove o título da URL ao fechar o modal
    this._router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        title: null
      },
      queryParamsHandling: 'merge'
    });
  }

  navigateToNext() {
    if (this.currentIndex < this.selectedSection.sections.length - 1) {
      this.currentIndex++;
    }
  }

  navigateToPrevious() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }
  getProgressPercentage(): number {
    if (!this.selectedSection || this.selectedSection.sections.length === 0) {
      return 0;
    }
    return ((this.currentIndex + 1) / this.selectedSection.sections.length) * 100;
  }

  @ViewChild('menuIcon') menuIcon!: ElementRef; @ViewChild('navbar') navbar!: ElementRef; public isMenuOpen: boolean = false;

  public navigateToGame() {
    let game=document.getElementById('gameFrame')
    game.style.visibility='visible';
    let main3=document.getElementById('main3')
    main3.remove();
    let main = document.getElementById("main");
    main.style.overflow='hidden';

    //    this._router.navigate(['gameevent',1592880902713],{ queryParams: {room: this.companyData.room}})
  }


  isSidebarOpen = true; // Inicialmente, a sidebar está visível

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen; // Alterna o estado da sidebar
  }
  public openContacts(){
    $('#jitsi-control-tutorial').click();
    if (isNaN(this._appData.instagramUser.uid)){
      let idx=$("#profileModal")
      this._appData.tiping=true;
      idx.modal('show');
    }
    else{
      $('#registerSocialModal').modal('show')
      this._appData.tiping=true;

    }
  }
  public ngOnDestroy() {

  }

  public processRoomMenu(){
    this.menuConfig.parse(this._appData.room.menuConfig);
    if (this._appData.admin){
      this.menuConfig.noCell=false;
      this.menuConfig.noBag=false;
    }
    if (this._appData.instagramUser && this._appData.instagramUser.uid=='T6sKpIAzwlPlYmEGgy2FuolQ2wN2'){
      this.menuConfig.noCell=false;
     this.menuConfig.noBag=false;
    }
  }

}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/treinamento/treinamento.component.ts